import Layout from 'components/layouts/main'
import Head from 'next/head'

export default function Moneyback() {
  return (
    <>
      <Head>
        <title key="title">TotalSystemCare | Money Back Guarantee</title>
      </Head>
      <Layout>
        <section className="hero-section">
          <div className="container policy-container">
            <div className="policy-wrapper">
              <div className="policy-title">
                <h1>Do you offer a Money Back Guarantee policy?</h1>
              </div>
              <p className="text">
                Yes! Our Money-back Guarantee Policy is good for 30 days from
                your purchase date. If at any time during the first thirty days
                of purchase, you are not satisfied then simply contact our
                support and we will refund your initial purchase. No questions
                asked.
              </p>{' '}
              <p className="text"> Last Updated on April 18, 2022</p>
            </div>
          </div>
        </section>
      </Layout>
    </>
  )
}
